<template>
  <div class="container">
    <h1>Press</h1>
    <div class="articles">
      <Article v-for="article in articles" :key="article.title" :title="article.title" :description="article.description" :url="article.url" :img="article.img"/>
    </div>
  </div>
</template>

<script>
import Article from '@/components/Article';

export default {
  data: function () {
    return {
      articles : [  
        {
          title: "Fashion Designer Kate Mack - Up Close and Personal: Part 1",
          description: "Kate Mack is a Black French designer based in the Haut Marais in Paris' 11th arrondissement. She has cultivated a space that looks at clothes as a sculptural extension of the body",
          url: "https://www.entreetoblackparis.com/blog/fashion-designer-kate-mack-up-close-and-personal-part-1",
          img: "https://www.entreetoblackparis.com/p/blog/Kate%20Mack_sustainable%20fashion%20designer_15%20rue%20Oberkampf_Paris%2011e_small.jpg"
        },
        {
          title: "Fashion Designer Kate Mack - Up Close and Personal: Part 2",
          description: "",
          url: "https://www.entreetoblackparis.com/blog/fashion-designer-kate-mack-up-close-and-personal-part-2",
          img: "https://www.entreetoblackparis.com/p/blog/Kate%20Mack_sustainable%20fashion%20designer_15%20rue%20Oberkampf_Paris%2011e_small.jpg"
        },
        {
          title: "Fashion Designer Kate Mack - Up Close and Personal: Part 3",
          description: "",
          url: "https://www.entreetoblackparis.com/blog/fashion-designer-kate-mack-up-close-and-personal-part-3",
          img: "https://www.entreetoblackparis.com/p/blog/Kate%20Mack_sustainable%20fashion%20designer_15%20rue%20Oberkampf_Paris%2011e_small.jpg"
        },
        {
          title: "TRUE Africa | Becoming Kate Mack",
          description: "On a bright and chilly Saturday morning in Paris, the fashion designer Kate Mack hastily crosses the lobby of The Hoxton. The ceiling is high and the lighting is dim. As she navigates her way around the antique furniture, I see that she is dressed in a simple yet stylish manner. Wearing full-black loose clothes, […]",
          url: "https://trueafrica.co/article/becoming-kate-mack/",
          img: "https://trueafrica.co/wp-content/uploads/2019/11/becoming-kate-mack-hero.jpg"
        },
        {
          title: "Made in Paris Fashion: Discovering the City's Dedicated Designers",
          description: "A few dedicated designers continue to create and produce their wares locally. A Made in Paris fashion label proves that high style can also be sustainable.",
          url: "https://www.parisperfect.com/blog/2019/11/made-in-paris-fashion/",
          img: "https://www.parisperfect.com/blog/wp-content/uploads/2019/11/Made-in-Paris-Fashion-by-Paris-Perfect-4.jpg"
        },
        {
          title: "Osez ! | Musée national de l'histoire de l'immigration",
          description: "Entretien avec Kate Mack par Mustapha Harzoune. Elle a ouvert sa boutique atelier à Paris, au début de la rue Oberkampf, à un saut de puce du Cirque d’Hiver. La rue grimpe jusque au boulevard de Ménilmontant, se pomponnant, tel un Soho londonien, de galeries, d’ateliers d’artistes et de designers, de boutiques et de show room, de restos et autres lounges-bars.",
          url: "https://www.histoire-immigration.fr/osez",
          img: "https://www.histoire-immigration.fr/sites/default/files/styles/diaporama_large/public/thumbnails/image/palais_lemaitre.jpg?itok=NTc4SFRd.cf.jpg"
        }
      ],
    }
  },
  components: {
    Article  
  },
  metaInfo: {
    // if no subcomponents specify a metaInfo.title, this title will be used
    title: `Kate Mack - Press`,
    // all titles will be injected into this template
    titleTemplate: null,
    description: 'Kate Mack Press',
    meta: [
      { charset: 'utf-8' },
      { 
        name: 'keywords',
        content: 'kate-mack, Kate, Mack, kate mack, Wearable Art Dealer, art, fashion, Local Designer, Small business, Designer, Artisan, Artisan Designer'
      },
      {
        property: 'og:title',
        content: 'Kate Mack',
        // following template options are identical
        // template: '%s - My page',
        template: chunk => `${chunk} - Press`,
        vmid: 'og:title'
      },
      {
        property: 'og:url',
        content: `https://kate-mack.com/press`,
        vmid: 'og:url'
      }
    ]
  },
}
</script>

<style lang="scss" scoped>
div.container {
  height: 100%;
}
div.articles {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  // align-items: center;
}
</style>
